// extracted by mini-css-extract-plugin
module.exports = {"colorPanel":"edit_colorPanel__FvXOW","row":"edit_row__2LHFy","customAttrs":"edit_customAttrs__26egF","optionsTable":"edit_optionsTable__1iBMQ","png":"edit_png__2-8H_"};